import React, { useState, useEffect } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import useStyles from './assetStyle';
import CrcAccordinDet1 from './crcAccordinDet1';
import CrcAccordinDet2 from './crcAccordinDet2';
import CrcAccordinDet3 from './crcAccordinDet3';
import CrcAccordinDet4 from './crcAccordinDet4';
import CrcAccordinDet5 from './crcAccordinDet5';
import CrcAccordinDet6 from './crcAccordinDet6';
import CrcAccordinDet7 from './crcAccordinDet7';
import CrcAccordinDet8 from './crcAccordinDet8';
import CrcAccordinDet9 from './crcAccordinDet9';
import CrcAccordinDet10 from './crcAccordinDet10';

export default function CrcAssetsAccordin(props) {
    const classes = useStyles();
    const [selectedValue, setSelectedValue] = React.useState('a');
    const [expanded, setExpanded] = React.useState('');
    const [updateValuesfromChild, setUpdateValuesfromChild] = React.useState('');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const handleChangeParent = (prop) => {
        setUpdateValuesfromChild({ prop });
    };

    return (
        <>
            <Grid item xs={12} sm={12}>
                <FormControl fullWidth>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                        className="mb15 mt15"
                        style={{ fontWeight: '500', color: '#4c4c4d', fontSize: '15px' }}
                    >
                        Details of Foreign Assets
                    </Typography>
                </FormControl>
            </Grid>
            <div className={classes.root1}>
                <Accordion square expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        className="padding10"
                    >
                        <Typography className={classes.heading}>1. Details of financial interest in any entity</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordContentSummary}>
                        <CrcAccordinDet1
                            rerenderApi={props.rerenderApi}
                            rerender={props.rerender}
                            apiResponseClient={props.apiResponse}
                            yesorNoType={props.yesorNoType}
                            addAdditionalQue={props.addAdditionalQue}
                            onChange={handleChangeParent}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion square expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                        className="padding10"
                    >
                        <Typography className={classes.heading}>2. Details of immovable property </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordContentSummary}>
                        <CrcAccordinDet2
                            rerenderApi={props.rerenderApi}
                            rerender={props.rerender}
                            apiResponseClient={props.apiResponse}
                            yesorNoType={props.yesorNoType}
                            addAdditionalQue={props.addAdditionalQue}
                            onChange={handleChangeParent}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion square expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3a-content"
                        id="panel3a-header"
                        className="padding10"
                    >
                        <Typography className={classes.heading}>
                            3. Details of any others capital asset held at any time during the previous year
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordContentSummary}>
                        <CrcAccordinDet3
                            rerenderApi={props.rerenderApi}
                            rerender={props.rerender}
                            apiResponseClient={props.apiResponse}
                            yesorNoType={props.yesorNoType}
                            addAdditionalQue={props.addAdditionalQue}
                            onChange={handleChangeParent}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion square expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel4a-content"
                        id="panel4a-header"
                        className="padding10"
                    >
                        <Typography className={classes.heading}>
                            4. Details of accounts in which you are a signing authority, which is not part of any of above list
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordContentSummary}>
                        <CrcAccordinDet4
                            rerenderApi={props.rerenderApi}
                            rerender={props.rerender}
                            apiResponseClient={props.apiResponse}
                            yesorNoType={props.yesorNoType}
                            addAdditionalQue={props.addAdditionalQue}
                            onChange={handleChangeParent}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion square expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel5a-content"
                        id="panel5a-header"
                        className="padding10"
                    >
                        <Typography className={classes.heading}>
                            5. Details of Trust created outside India, in which you are a trustee
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordContentSummary}>
                        <CrcAccordinDet5
                            rerenderApi={props.rerenderApi}
                            rerender={props.rerender}
                            apiResponseClient={props.apiResponse}
                            yesorNoType={props.yesorNoType}
                            addAdditionalQue={props.addAdditionalQue}
                            onChange={handleChangeParent}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion square expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel6a-content"
                        id="panel6a-header"
                        className="padding10"
                    >
                        <Typography className={classes.heading}>
                            6. Details of any other income derived from any other source outside India which is not included above
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordContentSummary}>
                        <CrcAccordinDet6
                            rerenderApi={props.rerenderApi}
                            rerender={props.rerender}
                            apiResponseClient={props.apiResponse}
                            yesorNoType={props.yesorNoType}
                            addAdditionalQue={props.addAdditionalQue}
                            onChange={handleChangeParent}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion square expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel7a-content"
                        id="panel7a-header"
                        className="padding10"
                    >
                        <Typography className={classes.heading}>
                            7. Details of foreign depository accounts held (including any beneficial interest) at any time during the year
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordContentSummary}>
                        <CrcAccordinDet7
                            rerenderApi={props.rerenderApi}
                            rerender={props.rerender}
                            apiResponseClient={props.apiResponse}
                            yesorNoType={props.yesorNoType}
                            addAdditionalQue={props.addAdditionalQue}
                            onChange={handleChangeParent}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion square expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel8a-content"
                        id="panel8a-header"
                        className="padding10"
                    >
                        <Typography className={classes.heading}>
                            8. Details of foreign custodial accounts held (including any beneficial interest) at any time during the year
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordContentSummary}>
                        <CrcAccordinDet8
                            rerenderApi={props.rerenderApi}
                            rerender={props.rerender}
                            apiResponseClient={props.apiResponse}
                            yesorNoType={props.yesorNoType}
                            addAdditionalQue={props.addAdditionalQue}
                            onChange={handleChangeParent}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion square expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel9a-content"
                        id="panel9a-header"
                        className="padding10"
                    >
                        <Typography className={classes.heading}>
                            9. Details of foreign equity and debt interest held (including any beneficial interest) in any entity at any
                            time during the year
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordContentSummary}>
                        <CrcAccordinDet9
                            rerenderApi={props.rerenderApi}
                            rerender={props.rerender}
                            apiResponseClient={props.apiResponse}
                            yesorNoType={props.yesorNoType}
                            addAdditionalQue={props.addAdditionalQue}
                            onChange={handleChangeParent}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion square expanded={expanded === 'panel10'} onChange={handleChange('panel10')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel10a-content"
                        id="panel10a-header"
                        className="padding10"
                    >
                        <Typography className={classes.heading}>
                            10. Details of foreign cash value insurance contract or annuity contract held (including any beneficial
                            interest) at any time during the year
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordContentSummary}>
                        <CrcAccordinDet10
                            rerenderApi={props.rerenderApi}
                            rerender={props.rerender}
                            apiResponseClient={props.apiResponse}
                            yesorNoType={props.yesorNoType}
                            addAdditionalQue={props.addAdditionalQue}
                            onChange={handleChangeParent}
                        />
                    </AccordionDetails>
                </Accordion>
            </div>
        </>
    );
}
